export default __webpack_public_path__ + "static/media/flyback_async_int_mosfet_ac_ssr.1b058011.svg";